//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Helmet } from 'react-helmet';
// import TagManager from 'react-gtm-module';

//components
import Lista from '../childrens/lista/.mixins/Lista';
import Alerta from "../../../../../util/snackbars/.mixins/";
import ModalRemove from "../childrens/modal_remove/.mixins/Modal_Remove";
import BotaoAdicionar from '../childrens/botao_adicionar/.mixins/Botao_Adicionar';
import CustomToolbar from '../childrens/customToolbar/.mixins';

//constrollers
import Grupo_controller from '../../../../../../controllers/grupo';
import Config from '../../../../../../controllers/config';
import Log from '../../../../../../controllers/log';

export default class Grupo extends Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();

        this.state = {
            itens: [],
            itensTable: [],
            title: props.route.title+'s',
            columns: [
                "Descrição",
                {
                    name: "Ações",
                    options: {
                      filter: false,
                      download: false,
                      customBodyRender: (value, tableMeta, updateValue) => (
                        <div>
                            <div>
                                <Tooltip title={'Apagar item'}>
                                    <a 
                                        onClick={(e)=>{this.inputRef.current.handleOpen(value.id)}} 
                                        style={{
                                            color:'#ff7676',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <DeleteIcon />
                                    </a>
                                </Tooltip>
                                <Tooltip title={'Editar item'}>
                                    <a
                                        href={"/#/grupos-ae/"+value.id}
                                        style={{color:'#6b61ff'}}
                                    >
                                        <EditIcon />
                                    </a>
                                </Tooltip>
                            </div>
                        </div>
                      )
                    }
                }
            ],
            customToolbar: null,
            isLoading: true,
            isError: false,
            error: null
        }
        
        //binds
        this.setState = this.setState.bind(this);
        this.handleAdicionar = this.handleAdicionar.bind(this);
        
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:grupo',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-grupo',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela lista de grupos!");
    }

    handleAdicionar() {
        this.props.router.push(this.props.route.path+'-ae');
    };

    UNSAFE_componentWillMount() {
        //carregamento de dados nos campos
        this.loadData(this);
        this.setState({
            customToolbar:() => <CustomToolbar {...this}/>,
        });
    }

    async loadData(props) {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            const r_grupos = await Grupo_controller.get(token);
            const j_r_grupos = JSON.parse(r_grupos.body);
            if (r_grupos.res.statusCode == 200) {
                props.setState({
                    itens: j_r_grupos.itens
                });
                var array = [];
                j_r_grupos.itens.forEach(element => {
                    var arrayPush = null;
                    arrayPush = [
                        element.descricao,
                        {id: element.id}
                    ];
                    array.push(arrayPush);
                });
                props.setState({
                    itensTable: array,
                    isLoading: false
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:grupo',
                //       eventAction: 'callback',
                //       eventLabel: 'sucesso:lista-grupos',
                //     }
                // });
            } else {
                if (
                    j_r_grupos.status == false && 
                    j_r_grupos.message && 
                    j_r_grupos.message.includes("Token inválido!")
                ) {
                    props.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }

            //auditoria
            var str = "Efetuada requisição para recuperação de dados de grupos! "
            +"Response:( Method: "+r_grupos.res.request.method
            +", StatusCode: "+r_grupos.res.statusCode
            +", Body: (limited 100chars)"+r_grupos.body.substr(0,100)
            +" )";
            Log.info(token,str);
        } catch (error) {
            props.child.current.retorno('Erro ao carregar dados!','error');
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:grupo',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            var str = "Erro na recuperação de dados de grupos! "
            +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    render() {
        return(
            <div>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} - Grupos`}</title>
                </Helmet>
                <Lista {...this}/>
                <Alerta ref={this.child}/>
                <ModalRemove ref={this.inputRef} pai={this}/>
            </div>
        );
    }

}